module.exports = __webpack_public_path__ + "img/location-grey.567e592f.svg";